<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1">Red Harvest</a></h1><a id="page_1">
<h1 class="subtitle">A Continental Op Case</h1>
<p class="author">Dashiell Hammett</p>
<div class="img_container">
<img alt="images" src="images/logo.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?4ee838ca